import "./CrewPage.css";
import video from "../../assets/Videos/crew_page_video.mp4";
import playVideo from "../../utils/playVideo";
import { useEffect, useRef } from "react";
import CubesAnim from "../Animation/CubesAnim";
const CrewPage = () => {
  let ref = useRef();
  useEffect(() => {
    playVideo(ref.current);
  });
  return (
    <div className="crewPage_wrapper">
      <video
        src={video}
        className="crewPage_video"
        loop
        muted
        ref={ref}
      ></video>
      <div className="crewCard_div">
        <div className="crew_card">
          <div>
            <h3>Goran Djuric</h3>
            <p>Chief Pilot</p>
            <p>Role: Take you safely to Kepler-22b</p>
          </div>
        </div>
        <div className="crew_card">
          <div>
            <h3>Doug Harley</h3>
            <p>Pilot, second in command</p>
            <p>Role: Take the lead, when needed</p>
          </div>
        </div>
        <div className="crew_card">
          <div>
            <h3>Sergey Ryzhikov</h3>
            <p>Technician</p>
            <p>Role: Make sure that everything is working properly</p>
          </div>
        </div>
        <div className="crew_card">
          <div>
            <h3>Soichi Noguchi</h3>
            <p>Medical support</p>
            <p>Role: Make sure that everyone is feeling right</p>
          </div>
        </div>
      </div>
      <CubesAnim />
    </div>
  );
};

export default CrewPage;
